import styled from 'styled-components';

const Span = styled.span`
  @include fontFamily('RobotoMedium');
`;

export default Span;
